import React from 'react'
import './Backdrop.css'




const Backdrop=(props)=> {

    return (
    <>
        <div className="backdropA" />
    </>
    )
}
export default Backdrop
